module.exports = __webpack_public_path__ + "static/media/um.4ff600b4.svg";